var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg1F48E = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BDDDF4",
    d: "M13 3H7l-7 9h10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5DADEC",
    d: "M36 12l-7-9h-6l3 9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4289C1",
    d: "M26 12h10L18 33z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8CCAF7",
    d: "M10 12H0l18 21zm3-9l-3 9h16l-3-9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5DADEC",
    d: "M18 33l-8-21h16z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg1F48E);
export { ForwardRef as ReactComponent };
export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\"><path fill=\"#BDDDF4\" d=\"M13 3H7l-7 9h10z\"></path><path fill=\"#5DADEC\" d=\"M36 12l-7-9h-6l3 9z\"></path><path fill=\"#4289C1\" d=\"M26 12h10L18 33z\"></path><path fill=\"#8CCAF7\" d=\"M10 12H0l18 21zm3-9l-3 9h16l-3-9z\"></path><path fill=\"#5DADEC\" d=\"M18 33l-8-21h16z\"></path></svg>";